import PropTypes from 'prop-types';
import styled from 'styled-components';

import passenger_1x from 'assets/images/success_page/passenger_1x.webp';
import passenger_2x from 'assets/images/success_page/passenger_2x.webp';
import passenger_3x from 'assets/images/success_page/passenger_3x.webp';

import { CHIME_CARD_METAL } from 'components/Products/CardPicker/cards';

export default function SuccessPageImage({ isMetalCardSelected }) {
  const imageProps = isMetalCardSelected
    ? {
        srcSet: CHIME_CARD_METAL.image,
        width: 270,
        height: 170,
        alt: CHIME_CARD_METAL.name,
      }
    : {
        srcSet: `${passenger_1x}?v=1x 1x, ${passenger_2x}?v=2x 2x, ${passenger_3x}?v=3x 3x`,
        width: 200,
        height: 190,
        alt: '',
      };

  return (
    <Image
      loading="eager"
      isMetalCardSelected={isMetalCardSelected}
      // fetchPriority="high" // uncomment once we use react 19
      {...imageProps}
    />
  );
}

SuccessPageImage.propTypes = {
  isMetalCardSelected: PropTypes.bool,
};

const Image = styled.img`
  margin: ${({ isMetalCardSelected }) =>
    isMetalCardSelected ? '3rem auto' : '0 auto'};
`;
